/* @flow */
// typecheck: ignore file
import React from 'react';

type Props = {
  to: string,
  push?: boolean,
};

class Redirect extends React.Component {
  props: Props;

  static defaultProps = {
    push: false,
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { router } = this.context;
    const { to, push } = this.props;

    const navigate = push ? router.push : router.replace;
    navigate(to);
  }

  render() {
    return null;
  }
}

export default Redirect;



// WEBPACK FOOTER //
// ./src/components/Redirect.jsx